import React, { useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import './Review.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { Player, BigPlayButton } from 'video-react';
import '../../node_modules/video-react/dist/video-react.css';
import img1 from '../assets/images/video1.png';
import img2 from '../assets/images/video2.png';
import img3 from '../assets/images/Immersion day.png';
import icanlogo from '../assets/images/ican.png';
import livelilogo from '../assets/images/liveli.png';
import gtcologo from '../assets/images/partners/images/GTCO_logo.svg';

import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

function VideoReview() {
    const [sliderRef, setSliderRef] = useState(null);

    var videosettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    var casestudy = [
        {
            id: 1,
            image: img2,
            link: 'https://cloudplexo.com/Liveli-Customer-Sucess.mp4',
            quote: '“I would defintely advise anyone anybody to migrate their cloud services with a partner like Cloudplexo.”',
            logo: livelilogo,
            speaker: 'CTO Liveli',
            caselink: '/liveli-case-study',
        },
        {
            id: 2,
            image: img1,
            link: 'https://cloudplexo.com/ICAN_ONLINE_TUTORS_final.mp4 ',
            title: 'CTO of Liveli',
            quote: '“We highly recommend Cloudplexo, if  you are having any challenges  with your website and mobile apps”',
            logo: icanlogo,
            speaker: 'Founder & CEO of IcanOnline Tutors',
            caselink: '/case-study-in-the-edtech-sector',
        },
        {
            id: 3,
            image: img3,
            link: 'https://cloudplexo.com/GT_Pension_Immersion+Day_Testimonial.mp4',
            company: 'Guarantee Trust Pension Managers',
            title: 'Cloudplexo Immersion Day',
            quote: `"I had a great time with the Cloudplexo team, learning more about AWS and the cloud"`,
            logo: gtcologo,
            speaker: 'Taiwo Owolabi',
            caselink: '#',
        },
    ];

    return (
        <React.Fragment>
            <div
                className="reviews"
                style={{ padding: '30px 0' }}
            >
                <Container>
                    <Row className="justify-content-center ">
                        <Col
                            lg="12"
                            md="12"
                            className="pt-2 text-center "
                        >
                            <div className="review-video ">
                                <Slider
                                    ref={setSliderRef}
                                    {...videosettings}
                                >
                                    {casestudy.map((cases) => (
                                        <div className="video-wrap">
                                            <div className="row m-0 row-no-gutters">
                                                <div className="image_wrap col-md-6">
                                                    <Player
                                                        playsInline
                                                        poster={cases.image}
                                                        className="video-player"
                                                        src={cases.link}
                                                    >
                                                        <BigPlayButton
                                                            position="center"
                                                            className="button-play"
                                                        />
                                                    </Player>
                                                </div>
                                                <div className="content_wrap col-md-6">
                                                    <img
                                                        src={cases.logo}
                                                        className="logo-image"
                                                        alt={cases.title}
                                                    />
                                                    <h6>{cases.company}</h6>
                                                    <p className="quote">
                                                        {cases.quote}
                                                    </p>
                                                    <p className="quote-speaker">
                                                        {cases.speaker}
                                                    </p>
                                                    <a
                                                        className="btn"
                                                        href={cases.caselink}
                                                    >
                                                        Read case study
                                                    </a>
                                                    <div className="controls">
                                                        <button
                                                            onClick={
                                                                sliderRef?.slickPrev
                                                            }
                                                        >
                                                            <BsArrowLeft
                                                                size={25}
                                                                color="#3E54AC"
                                                            />
                                                        </button>
                                                        <button
                                                            onClick={
                                                                sliderRef?.slickNext
                                                            }
                                                        >
                                                            <BsArrowRight
                                                                size={25}
                                                                color="#3E54AC"
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default VideoReview;
